import { render, staticRenderFns } from "./ByProject.vue?vue&type=template&id=1f970af4&"
import script from "./ByProject.vue?vue&type=script&lang=ts&"
export * from "./ByProject.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports